export default function AutocompleteDirective() {
  return {
    restrict: 'E',
    template: require('./autocomplete.html'),
    scope: {
      inputName: '@',
      itemLabelField: '@',
      items: '<',
      label: '@',
      placeholder: '@',
      required: '<',
      selectedItem: '=',
      getItemClass: '&',
      selectedItemChange: '&',
      position: '@',
    },
    controller: 'AutocompleteController',
    controllerAs: 'autocompleteVM',
    bindToController: true,
    replace: true,
  };
}
